import { ClassroomRepository } from '@xq/infrastructure';

export class PersistClassroomIsArchivedUseCase {
  static async execute(classroomId: string, isArchived: boolean) {
    const classroomRepository = new ClassroomRepository();

    return classroomRepository.persistIsArchived(classroomId, isArchived);
  }
}
